module.exports = __webpack_public_path__ + "img/zu10.96f86e46.png";